import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface PaymentWizardSettingsState {
    clinicAppSchedAndBuy: string /**  Determina si hay que habilita la compra desde la app: -1 opcional, -2 obligatorio, 0 Desactivado */;
    productList: string /** Son los bonos que tenemos que comprar para pedir cita de este servicio */;
    urlPayment: string;
}

export function createInitialState(): PaymentWizardSettingsState {
    return {
        clinicAppSchedAndBuy: null,
        productList: '',
        urlPayment: '',
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'payment-wizard-settings', resettable: true })
export class PaymentWizardSettingsStore extends Store<
    PaymentWizardSettingsState
> {
    constructor() {
        super(createInitialState());
    }
}
